module.exports = __webpack_public_path__ + "static/2-a9bf9330b07b1733d00ed982826d021d.jpg";